import {ContainerFacade} from '@igp/shared/ioc-container';
import type {IEntityReadService} from '@igp/shared/redux/entity';

import {KeycloakLogServiceTypes} from './constants';
import {KeycloakLogService} from './service';
import type {KeycloakLogEntityType} from './types';

export class KeycloakLogContainerFacade extends ContainerFacade {
    bindAll() {
        this._container.bind<IEntityReadService<KeycloakLogEntityType>>(KeycloakLogServiceTypes.service).to(KeycloakLogService);
    }
}
